import { render, staticRenderFns } from "./select-city.vue?vue&type=template&id=6d63fdf7"
import script from "./select-city.vue?vue&type=script&lang=ts"
export * from "./select-city.vue?vue&type=script&lang=ts"
import style0 from "./select-city.vue?vue&type=style&index=0&id=6d63fdf7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports